import { render, staticRenderFns } from "./TextField.vue?vue&type=template&id=50b948e4&scoped=true"
import script from "./TextField.vue?vue&type=script&lang=js"
export * from "./TextField.vue?vue&type=script&lang=js"
import style0 from "./TextField.vue?vue&type=style&index=0&id=50b948e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b948e4",
  null
  
)

export default component.exports